exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".history-list-history-list-1VOUO{width:100%;height:calc(100% - 92px);overflow-y:scroll;overflow-x:hidden}.history-list-history-list-tab-show-22v22{height:calc(100% - 122px)}", ""]);

// Exports
exports.locals = {
	"history-list": "history-list-history-list-1VOUO",
	"history-list-tab-show": "history-list-history-list-tab-show-22v22"
};